import React from 'react';
import FullLogo from '../Photos/Fulllogo.png';
import Bunks1 from '../Photos/bunk1.jpg';
import Bunks2 from '../Photos/bunk2.jpg';
import GeneralImage from '../Photos/generalimage.jpg';
import BunksCAD1 from '../Photos/BunksCAD1.png';
import BunksCAD2 from '../Photos/BunksCAD2Z.png';
import BunksCAD3 from '../Photos/BunksCAD3.png';
import BunksCAD4 from '../Photos/BunksCAD4.png';
import BunksCAD5 from '../Photos/BunksCAD5.png';

function BottemlessBunks() {
  return (
    <div className="container mt-5">

 {/* Additional Images */}
      <div className="row g-4 mb-5">
        <div className="col-md-4">
          <img src={Bunks1} alt="Image 1" className="img-fluid rounded shadow" />
          <p className="text-center mt-2"></p>
        </div>
        <div className="col-md-4">
          <img src={Bunks2} alt="Image 2" className="img-fluid rounded shadow" />
          <p className="text-center mt-2"></p>
        </div>
        <div className="col-md-4">
          <img src={BunksCAD3} alt="Image 3" className="img-fluid rounded shadow" />
          <p className="text-center mt-2"></p>
        </div>
      </div>

  {/* Full-Width Image Section with Two Images Side by Side */}
      <div className="row g-0 mb-5">
        <div className="col-md-6">
          <img src={BunksCAD5} alt="Full Width Image 1" className="img-fluid w-100" />
        </div>
        <div className="col-md-6">
          <img src={BunksCAD4} alt="Full Width Image 2" className="img-fluid w-100" />
        </div>
      </div>

      {/* Full-Width Text Box */}
      <div className="get-in-touch-card mb-5 p-4">
        <div className="card-body">
          <h2 style={{ color: '#c92424' }}>Bottomless Feedbunk</h2>
          <p className="card-text">
            Our standard bottomless bunks are 26 feet long, 26 inches tall (dimension 1), and 30.5 inches wide (dimension 2) with a top bar 6 inches up (dimension 3) and off center (dimension 4). 
            The standard bunks are built for fence line feeding silage and ground hay to cows post calving, but we can easily tailor different dimensions to make them fit you application. 
            
          </p>
        </div>
      </div>

 

          {/* Google Maps and Address Section */}
      <div className="row mb-5">
        <div className="col-md-6">
          <h3 className="text-info mb-3">Find Us on the Map</h3>
          <iframe
            title="Google Map Location"
             src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d137778.5034484805!2d-96.8170804273567!3d40.26456281736707!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x879642a907fb410b%3A0x92e39ab059d18d3d!2sBeatrice%2C%20NE%2068310!5e0!3m2!1sen!2sus!4v1756762112857!5m2!1sen!2sus" 
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
        <div className="col-md-6 d-flex flex-column">
          <h3 className="text-info mb-3">Contact Us</h3>
          <div className="card p-3 enlarged-address-card flex-grow-1">
            <p className="card-text">
             Location: <br />
              
            
              Beatrice, NE 68310<br />
              <br />
              <br />
              Email: eoltmans3@gmail.com<br />
              <br />
              Phone: (402) 239-4323
            </p>
          </div>
          <div className="flex-grow-1 mt-3">
            <img src={FullLogo} alt="Company Logo" className="img-fluid w-100" style={{ width: '100%', objectFit: 'cover' }} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BottemlessBunks;